export default __webpack_public_path__ + "static/szns_logo_icon_full-color-4d88a294541bbfb4525c2db8061f1270.png";